import { defineMessages } from 'react-intl';

/** Streaming → Short video (design streaming-sections c1, c2, e2). */
export const shortVideoMessages = defineMessages({
  emptyTitle: {
    id: 'app.sml.streaming.shortVideo.empty.title',
    defaultMessage: 'See the videos people make with your songs',
  },
  emptyText: {
    id: 'app.sml.streaming.shortVideo.empty.text',
    defaultMessage:
      'Your connected sources do not report short videos. Connect a source that does, and MUSIC24 shows the videos that other people make with your songs.',
  },
  platformLabel: { id: 'app.sml.streaming.shortVideo.platform.label', defaultMessage: 'Platform' },
  allPlatforms: { id: 'app.sml.streaming.shortVideo.platform.all', defaultMessage: 'All platforms' },
  intro: {
    id: 'app.sml.streaming.shortVideo.intro',
    defaultMessage: 'Videos that other people made with your songs on short-video apps, as {source} reports them.',
  },
  creations: { id: 'app.sml.streaming.shortVideo.creations', defaultMessage: 'Videos made' },
  views: { id: 'app.sml.streaming.shortVideo.views', defaultMessage: 'Views' },
  likes: { id: 'app.sml.streaming.shortVideo.likes', defaultMessage: 'Likes' },
  shares: { id: 'app.sml.streaming.shortVideo.shares', defaultMessage: 'Shares' },
  comments: { id: 'app.sml.streaming.shortVideo.comments', defaultMessage: 'Comments' },
  favourites: { id: 'app.sml.streaming.shortVideo.favourites', defaultMessage: 'Favourites' },
  perDay: { id: 'app.sml.streaming.shortVideo.perDay', defaultMessage: 'Per day' },
  byPlatform: { id: 'app.sml.streaming.shortVideo.byPlatform', defaultMessage: 'By platform' },
  byTrack: { id: 'app.sml.streaming.shortVideo.byTrack', defaultMessage: 'By track' },
  platformColumn: { id: 'app.sml.streaming.shortVideo.column.platform', defaultMessage: 'Platform' },
  trackColumn: { id: 'app.sml.streaming.shortVideo.column.track', defaultMessage: 'Track' },
  videosColumn: { id: 'app.sml.streaming.shortVideo.column.videos', defaultMessage: 'Videos' },
  watchColumn: { id: 'app.sml.streaming.shortVideo.column.watch', defaultMessage: 'Watch time' },
  changeColumn: { id: 'app.sml.streaming.shortVideo.column.change', defaultMessage: 'Change' },
  watchSeconds: { id: 'app.sml.streaming.shortVideo.watchSeconds', defaultMessage: '{seconds} s' },
  trackNote: {
    id: 'app.sml.streaming.shortVideo.trackNote',
    defaultMessage:
      'Watch time is the average time a viewer watched a video with this track. A dash: the platform does not give this number.',
  },
  noPlatformTitle: {
    id: 'app.sml.streaming.shortVideo.noPlatform.title',
    defaultMessage: 'No {platform} videos with your songs in {start} – {end}',
  },
  noPlatformText: {
    id: 'app.sml.streaming.shortVideo.noPlatform.text',
    defaultMessage: '{source} reports {platform} for the releases that it sends there.',
  },
  noVideosTitle: {
    id: 'app.sml.streaming.shortVideo.noVideos.title',
    defaultMessage: 'No videos with your songs in {start} – {end}',
  },
  noVideosText: {
    id: 'app.sml.streaming.shortVideo.noVideos.text',
    defaultMessage: 'When people use your songs in short videos, {source} reports them here.',
  },
  showAllPlatforms: { id: 'app.sml.streaming.shortVideo.showAll', defaultMessage: 'Show all platforms' },
});
